import script from "./APIDashboardLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./APIDashboardLoader.vue?vue&type=script&setup=true&lang=js"

import "./APIDashboardLoader.vue?vue&type=style&index=0&id=1e7db878&lang=css"

const __exports__ = script;

export default __exports__